/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */


import { RootState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

interface CountryData {
  code: string;
  name: string;
}

export const getCountries = ({ common }: RootState): CountryData[] => common.loaded ? common.data.countries : [];

export const getCountryOptions = createSelector([getCountries], (countries) => {
  return countries.map(c => ({ value: c.code, label: c.name }));
})
